<template>
  <div class="block">
    <div :class="item.gray && 'bg-gray'" v-for="item in rows" :key="item.key">
      <div class="container">
        <!--  -->
        <div class="row card">
          <div class="col-percent-30">
            <div class="wrap-left">
              <div class="wrap-img">
                <img :src="item.img1" class="img-responsive" alt="" />
              </div>

              <div>
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="col-percent-70">
            <div class="card-t">建设方案</div>
            <div class="card-c">
              {{ item.text1 }}
            </div>
            <div class="card-t">项目价值/效益</div>
            <div class="card-c">
              {{ item.text2 }}
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="box-img">
                  <img :src="item.img2" class="img-responsive" alt="" />
                </div>
              </div>
              <div class="col-sm-6" v-show="!isMobile">
                <div class="box-img">
                  <img :src="item.img3" class="img-responsive" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import p1 from "@/assets/images/case/p1.png";
import p2 from "@/assets/images/case/p2.png";
import p3 from "@/assets/images/case/p3.png";
import p4 from "@/assets/images/case/p4.png";

import p5 from "@/assets/images/case/p5.png";
import p6 from "@/assets/images/case/p6.png";
import p7 from "@/assets/images/case/p7.png";

import p8 from "@/assets/images/case/p8.png";
import p9 from "@/assets/images/case/p9.png";
import p10 from "@/assets/images/case/p10.png";

import p11 from "@/assets/images/case/p11.png";
import p12 from "@/assets/images/case/p12.png";
import p13 from "@/assets/images/case/p13.png";
import p14 from "@/assets/images/case/p14.png";
import p15 from "@/assets/images/case/p15.png";

const rows = [
  {
    key: 1,
    img1: p1,
    img2: p2,
    img3: p3,
    title:
      "中骏集团业务体系涵盖住宅开发、商业地产、长租公寓、文化旅游地产、产业地产，大型购物中心的营运管理、住宅与公共设施的物业管理、教育、健康管理等业务板块，以及基金管理及投资等金融服务。",
    text1:
      "统一从准备、起草、审批、用印到签订的合同审批流程，实现合同管理标准化、智能化和数字化。与明源系统集成、K2系统审批集成。",
    text2:
      "合同模板规范化从0突破，截至目前已有130个标准合同。合同签订风险性降幅明显。",
  },
  {
    key: 2,
    gray: true,
    img1: p4,
    img2: p5,
    img3: p6,
    title:
      "南通市华德房地产开发有限公司创建于1992年，与南通四建同为达海控股集团旗下核心子公司，注册资本金27120万元人民币，2008年取得房地产开发壹级资质。目前拥有员工130余名，专业技术人员80余名。",
    text1:
      "强化法务部门对合同签订的监控力度，有效控制了企业经营风险，并提供实时、准确、全面的合同签订和执行数据。为各级管理者的管理提供支持",
    text2:
      "法务部门监控合同从编辑到签订、到归档全过程。降低合同签单失败的风险性。",
  },
  {
    key: 3,
    img1: p7,
    img2: p8,
    img3: p9,
    title:
      "信达生物成立于2011年，致力于开发、生产和销售用于治疗肿瘤等重大疾病的创新药物。2018年10月31日，信达生物制药在香港联交所主板挂牌上市，股票代码：01801。",
    text1:
      "强化法务部门对合同签订的监控力度，有效控制了企业经营风险，并提供实时、准确、全面的合同签订和执行数据。为各级管理者的管理提供支持",
    text2:
      "进度款、收付款、发票、收发货相匹配，使款、票、物一致。按照合同条款管控资源、 活动、采购物料以及交付物品相匹配。以模板管控为业务核心，涉及合同的模板草拟、审核、付款管控，提供完整管理功能。",
  },
  {
    key: 4,
    gray: true,
    img1: p10,
    img2: p11,
    img3: p12,
    title:
      "日出东方创立于1999年，是一家致力于“清洁世界，美好生活”的上市科技企业集团，是清洁能源创新开发和高效利用的开拓者，累计为2500万家庭和20000+工程客户提供清洁热水、热能解决方案。",
    text1:
      "关联企业原有的BPM合同审批流程，与企业原有SAP、REIP对接，实现数据同步共享。",
    text2:
      "统一模版管理，并做到及时更新和推广；规范合同审批流程，为领导层决策提供数据支撑。",
  },
  {
    key: 5,
    img1: p13,
    img2: p14,
    img3: p15,
    title:
      "路劲地产集团有限公司成立于2003年，是路劲基建有限公司房地产业务的旗舰公司。按中国房地产业协会及中国房地产测评中心2021年发出的报告，路劲地产位列外资房地产开发企业第1名、全国房企35强。 ",
    text1:
      "合同管理系统与明源、招采、OA集成，为这些系统提供合同范本、草拟、比对等功能。",
    text2: "提升标准合同使用率，降低合同法律风险，提高合同管理效率。",
  },
];
export default {
  data() {
    return {
      rows,
    };
  },
};
</script>

<style scoped>
.card {
  padding: 60px 0;
  display: flex;
}
.bg-gray {
  background-color: #f6f8fc;
}
.card-t {
  font-size: 22px;
  color: #3975ea;
  padding-left: 20px;
  border-left: 2px solid #f6c946;
  margin-bottom: 20px;
  line-height: 1;
}
.card-c {
  color: #848484;
  font-size: 16px;
  margin-bottom: 20px;
}

.wrap-left {
  border: 1px solid #ececec;
  background: #fff;
  height: 100%;
  padding: 40px 20px;
  font-size: 16px;
  color: #666;
}
.wrap-left .wrap-img {
  width: 80%;
  margin: 20px auto;
  margin-bottom: 40px;
}
.wrap-left .wrap-img img {
  margin: 0 auto;
}

.col-percent-30 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 30%;
}
.col-percent-70 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 70%;
}

/*  */
.mb .card {
  display: inherit;
}
.mb .wrap-left {
  margin-bottom: 30px;
}
.mb .col-percent-30 {
  width: 100%;
}
.mb .col-percent-70 {
  width: 100%;
}
</style>